import { render, staticRenderFns } from "./SeveranceList.vue?vue&type=template&id=8e2b9706"
import script from "./SeveranceList.vue?vue&type=script&lang=js"
export * from "./SeveranceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports